var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6387 6.03125H15.2969C15.5898 6.03125 15.8535 6.23633 15.9414 6.5293C16.0586 6.79297 15.9414 7.11523 15.707 7.29102L11.8691 10.2793L13.3633 14.9668C13.4805 15.2598 13.3633 15.582 13.0996 15.7578C12.8652 15.9336 12.5137 15.9336 12.2793 15.7285L8.5 12.7988L4.69141 15.7285C4.45703 15.9336 4.10547 15.9336 3.87109 15.7578C3.60742 15.582 3.49023 15.2598 3.60742 14.9668L5.10156 10.2793L1.26367 7.29102C1.0293 7.11523 0.912109 6.79297 1.0293 6.5293C1.11719 6.23633 1.38086 6.03125 1.70312 6.03125H6.33203L7.82617 1.37305C7.91406 1.08008 8.17773 0.875 8.5 0.875C8.79297 0.875 9.05664 1.08008 9.14453 1.37305L10.6387 6.03125Z",
    fill: "#EEDD5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar2);
export default __webpack_public_path__ + "static/media/star2.ddb6d7e9e1ff0e86d1ed3821d5cdecda.svg";
export { ForwardRef as ReactComponent };